import { EcommerceAPIApi as EcommerceApi, DBTicket } from '@parkingbase/ecommerce-api-dev';
import type { RawAxiosRequestConfig } from 'axios';
import { BaseApiService } from './baseApi.service';

// The backend endpoint `/corporateValidation/search/ticket/new` actually returns
// `com.valetmanager.api.models.saverequests.TicketSearchResponse` — a wrapper object
// with a nested `ticket: DBTicket`. However, the generated `@parkingbase/ecommerce-api-dev`
// types incorrectly claim the response is `DBTicket`: (1) the controller has
// `@Schema(implementation = DBTicket.class) //TODO: We need to fix this properly`,
// and (2) there are two Java classes named `TicketSearchResponse` (saverequests +
// gatearm) — OpenAPI emits only the flat gatearm one. See PB-826.
interface TicketSearchResponseWrapper {
  ticket?: DBTicket;
}

export class TicketService extends BaseApiService {
  protected ticketApi: EcommerceApi;
  protected corporateValidationApi: EcommerceApi;

  constructor() {
    super();
    this.ticketApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
    this.corporateValidationApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  async getNearbyTransientTickets(
    centreX: number,
    centreY: number,
    plate: string,
    options?: RawAxiosRequestConfig
  ) {
    const response = await this.ticketApi.getNearbyTransientTickets(
      centreX,
      centreY,
      plate,
      options
    );
    return response.data;
  }

  async searchTicket(
    ticketNumber?: string,
    ticketId?: string,
    licensePlateNumber?: string,
    options?: RawAxiosRequestConfig
  ): Promise<DBTicket | null> {
    const response = await this.corporateValidationApi.searchTicketNew(
      ticketNumber,
      ticketId,
      licensePlateNumber,
      options
    );
    const wrapper = response.data as unknown as TicketSearchResponseWrapper | null;
    // Empty wrapper (no matching ticket) also has `ticket` populated as a blank
    // DBTicket by the backend — treat tickets without an `id` as "not found".
    const ticket = wrapper?.ticket;
    return ticket?.id ? ticket : null;
  }
}
